<template>
  <div>
    <div class="detail-picture">
      <div class="detail-image">
        <div
          v-for="(src, index) in images"
          :src="src"
          :index="index"
          :key="index"
        >
          <div class="detail-image-wrapper" v-if="imageIndex === index">
            <img aspect-ratio="0.9" :src="src" />
          </div>
        </div>

        <div class="detail-image-texture">
          <v-img
            :src="
              require(`@/assets/img/texture_${Math.floor(
                Math.random() * 4
              )}.jpg`)
            "
          ></v-img>
        </div>
      </div>
      <div class="detail-picture-diploma">{{ graduate.diploma }}</div>
      <div class="detail-picture-year"><span>2</span>0<span>2</span>0</div>
      <div class="detail-picture-website">
        remisetitres.fr.ch<br />uebergabeltitel.fr.ch
      </div>
    </div>
    <div class="detail-info">
      <div
        class="detail-info-name"
        v-html="graduate.firstname + ' ' + graduate.lastname"
      ></div>
      <div class="detail-info-profession" v-html="graduate.profession"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    graduate: Object
  },
  data() {
    return {
      imageIndex: 0
    }
  },
  mounted() {
    setInterval(() => {
      if (this.imageIndex < this.imagesLenght - 1) {
        this.imageIndex++
      } else {
        this.imageIndex = 0
      }
    }, 500)
  },
  computed: {
    images() {
      return this.graduate.pictures_list.map(src => {
        return src.replace(
          'public://pictures',
          'https://api.frogfish.dev/sites/default/files/styles/portrait/public/pictures'
        )
      })
    },
    imagesLenght() {
      return this.graduate.pictures_list.length
    }
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.detail-picture {
  position: relative;
  margin: 0 auto 40px;
  max-width: 540px;
  padding: 60px 20px 140px 82px;
  border: solid 2px #000;
  box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.55);
  background: #fff;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 30px 10px 70px 41px;
    margin-bottom: 0;
  }
}

.detail-image {
  position: relative;

  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.detail-image-wrapper {
  padding-top: 111%;
  position: relative;

  > img {
    position: absolute;
    top: 0;
    width: 100%;
  }
}

.detail-image-texture {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  opacity: 0.4;

  .v-image {
    height: 100%;
    object-fit: cover;
  }
}

.detail-picture-diploma {
  position: absolute;
  bottom: 0;
  left: 0;
  padding-left: 10px;

  font-size: 130px;
  line-height: 1;

  transform: translateY(100%) rotate(-90deg);
  transform-origin: top left;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    font-size: 65px;
  }
}

.detail-picture-year {
  position: absolute;
  top: 0;
  left: 0;
  padding-right: 10px;

  font-size: 130px;
  line-height: 1;
  -webkit-text-stroke: 1px black;
  -webkit-text-fill-color: transparent;

  transform: translateX(-100%) rotate(-90deg);
  transform-origin: top right;

  span {
    font-family: 'Langulaire';
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    font-size: 65px;
  }
}

.detail-picture-website {
  position: absolute;
  right: 10px;
  bottom: 6px;

  font-size: 11px;
  line-height: 14px;
  text-align: right;
}

.detail-info {
  max-width: 540px;
  margin: 0 auto;
  padding: 25px 0;
  text-align: center;
}

.detail-info-name {
  margin-bottom: 0.2em;

  font-size: 1.5em;
  line-height: 1.3;
  text-transform: uppercase;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    font-size: 16px;
  }
}

.detail-info-profession {
  font-size: 1.5em;
  line-height: 1.3;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    font-size: 16px;
  }
}
</style>
